import React from "react";
import { Link } from "react-router-dom";
export default class Carpenter extends React.Component 
{
    render()
     {
        return <div>
                 <div className="container-fluid py-5">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Our Services</h6>
                    <h1 className="mb-4 section-title">Awesome Carpenter Services For You</h1>
                    <p>Invidunt lorem justo clita. Erat lorem labore ea, justo dolor lorem ipsum ut sed eos, ipsum et dolor kasd sit ea justo. Erat justo sed sed diam. Ea et erat ut sed diam sea ipsum</p>
                    <Link to="https://www.justdial.com/Indore/Deep-Carpenter-Services/nct-11260522" className="btn btn-primary mt-3 py-2 px-4">More Services</Link>
                </div>
                <div className="col-lg-6 pt-5 pt-lg-0">
                    <div className="owl-carousel service-carousel position-relative">
                        <div className="d-flex flex-column align-items-center text-center bg-light rounded overflow-hidden pt-4">
                            <div className="icon-box bg-light text-secondary shadow mt-2 mb-4">
                                <i className="fa fa-2x fa-hotel"></i>
                            </div>
                            <h5 className="font-weight-bold mb-4 px-4">Carpenter Services</h5>
                            <img src="img/blog-1.jpg" alt=""/>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>




{/* jayshreeram */}
<section className="bg0 p-t-23 p-b-140">
		<div className="container">
			<div className="p-b-10">
				<h3 className="ltext-103 cl5">
					Services Overview
				</h3>
			</div>

			<div className="flex-w flex-sb-m p-b-52">
			
				<div className="flex-w flex-c-m m-tb-10">
					<div className="flex-c-m stext-106 cl6 size-104 bor4 pointer hov-btn3 trans-04 m-r-8 m-tb-4 js-show-filter">
						<i className="icon-filter cl2 m-r-6 fs-15 trans-04 zmdi zmdi-filter-list"></i>
						<i className="icon-close-filter cl2 m-r-6 fs-15 trans-04 zmdi zmdi-close dis-none"></i>
						 Filter
					</div>

					<div className="flex-c-m stext-106 cl6 size-105 bor4 pointer hov-btn3 trans-04 m-tb-4 js-show-search">
						<i className="icon-search cl2 m-r-6 fs-15 trans-04 zmdi zmdi-search"></i>
						<i className="icon-close-search cl2 m-r-6 fs-15 trans-04 zmdi zmdi-close dis-none"></i>
						Search
					</div>
				</div>
				
				{/* Search product */}
				<div className="dis-none panel-search w-full p-t-10 p-b-15">
					<div className="bor8 dis-flex p-l-15">
						<button className="size-113 flex-c-m fs-16 cl2 hov-cl1 trans-04">
							<i className="zmdi zmdi-search"></i>
						</button>

						<input className="mtext-107 cl2 size-114 plh2 p-r-15" type="text" name="search-product" placeholder="Search"/>
					</div>	
				</div>

				{/* Filter */}
				<div className="dis-none panel-filter w-full p-t-10">
					<div className="wrap-filter flex-w bg6 w-full p-lr-40 p-t-27 p-lr-15-sm">
						<div className="filter-col1 p-r-15 p-b-27">
							<div className="mtext-102 cl2 p-b-15">
								Sort By
							</div>

							<ul>
								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										Default
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										Popularity
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										Average rating
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04 filter-link-active">
										Newness
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										Price: Low to High
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										Price: High to Low
									</Link>
								</li>
							</ul>
						</div>

						<div className="filter-col2 p-r-15 p-b-27">
							<div className="mtext-102 cl2 p-b-15">
								Price
							</div>

							<ul>
								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04 filter-link-active">
										All
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										$0.00 - $50.00
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										$50.00 - $100.00
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										$100.00 - $150.00
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										$150.00 - $200.00
									</Link>
								</li>

								<li className="p-b-6">
									<Link to="#" className="filter-link stext-106 trans-04">
										$200.00+
									</Link>
								</li>
							</ul>
						</div>

						<div className="filter-col3 p-r-15 p-b-27">
							<div className="mtext-102 cl2 p-b-15">
								Color
							</div>

							<ul>
								<li className="p-b-6">
									<span className="fs-15 lh-12 m-r-6" style={{color: "#222"}}>
										<i className="zmdi zmdi-circle"></i>
									</span>

									<Link to="#" className="filter-link stext-106 trans-04">
										Black
									</Link>
								</li>

								<li className="p-b-6">
									<span className="fs-15 lh-12 m-r-6" style={{color: "#4272d7"}}>
										<i className="zmdi zmdi-circle"></i>
									</span>

									<Link to="#" className="filter-link stext-106 trans-04 filter-link-active">
										Blue
									</Link>
								</li>

								<li className="p-b-6">
									<span className="fs-15 lh-12 m-r-6" style={{color: "b3b3b3"}}>
										<i className="zmdi zmdi-circle"></i>
									</span>

									<Link to="#" className="filter-link stext-106 trans-04">
										Grey
									</Link>
								</li>

								<li className="p-b-6">
									<span className="fs-15 lh-12 m-r-6" style={{color: "#00ad5f"}}>
										<i className="zmdi zmdi-circle"></i>
									</span>

									<Link to="#" className="filter-link stext-106 trans-04">
										Green
									</Link>
								</li>

								<li className="p-b-6">
									<span className="fs-15 lh-12 m-r-6" style={{color: "#fa4251"}}>
										<i className="zmdi zmdi-circle"></i>
									</span>

									<Link to="#" className="filter-link stext-106 trans-04">
										Red
									</Link>
								</li>

								<li className="p-b-6">
									<span className="fs-15 lh-12 m-r-6" style={{color: "#aaa"}}>
										<i className="zmdi zmdi-circle-o"></i>
									</span>

									<Link to="#" className="filter-link stext-106 trans-04">
										White
									</Link>
								</li>
							</ul>
						</div>

						<div className="filter-col4 p-b-27">
							<div className="mtext-102 cl2 p-b-15">
								Tags
							</div>

							<div className="flex-w p-t-4 m-r--5">
								<Link to="#" className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Fashion
								</Link>

								<Link to="#" className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Lifestyle
								</Link>

								<Link to="#" className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Denim
								</Link>

								<Link to="#" className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Streetstyle
								</Link>

								<Link to="#" className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Crafts
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row isotope-grid">
				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Premium Home Deep Carpenter
								</Link>

								<span className="stext-105 cl3">
									$16.64
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Herschel supply
								</Link>

								<span className="stext-105 cl3">
									$35.31
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item men">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Only Check Trouser
								</Link>

								<span className="stext-105 cl3">
									$25.50
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Classic Trench Coat
								</Link>

								<span className="stext-105 cl3">
									$75.00
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Front Pocket Jumper
								</Link>

								<span className="stext-105 cl3">
									$34.75
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item watches">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Vintage Inspired Classic 
								</Link>

								<span className="stext-105 cl3">
									$93.20
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Shirt in Stretch Cotton
								</Link>

								<span className="stext-105 cl3">
									$52.66
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Pieces Metallic Printed
								</Link>

								<span className="stext-105 cl3">
									$18.96
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item shoes">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Converse All Star Hi Plimsolls
								</Link>

								<span className="stext-105 cl3">
									$75.00
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Femme T-Shirt In Stripe
								</Link>

								<span className="stext-105 cl3">
									$25.85
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item men">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Herschel supply 
								</Link>

								<span className="stext-105 cl3">
									$63.16
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item men">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Herschel supply
								</Link>

								<span className="stext-105 cl3">
									$63.15
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									T-Shirt with Sleeve
								</Link>

								<span className="stext-105 cl3">
									$18.49
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<section className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="#" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Pretty Little Thing
								</Link>

								<span className="stext-105 cl3">
									$54.79
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</section>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item watches">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Mini Silver Mesh Watch
								</Link>

								<span className="stext-105 cl3">
									$86.85
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-6 col-md-6 col-lg-3 p-b-35 isotope-item women">
					{/* Block2 */}
					<div className="block2">
						<div className="block2-pic hov-img0">
							<img src="images/product-04.jpg" alt="IMG-PRODUCT"/>

							<Link to="/ProductDetail" className="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</Link>
						</div>

						<div className="block2-txt flex-w flex-t p-t-14">
							<div className="block2-txt-child1 flex-col-l ">
								<Link to="product-detail.html" className="stext-104 cl4 hov-cl1 trans-04 js-name-b2 p-b-6">
									Square Neck Back
								</Link>

								<span className="stext-105 cl3">
									$29.64
								</span>
							</div>

							<div className="block2-txt-child2 flex-r p-t-3">
								<Link to="#" className="btn-addwish-b2 dis-block pos-relative js-addwish-b2">
									<img className="icon-heart1 dis-block trans-04" src="images/icons/icon-heart-01.png" alt="ICON"/>
									<img className="icon-heart2 dis-block trans-04 ab-t-l" src="images/icons/icon-heart-02.png" alt="ICON"/>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Load more */}
			<div className="flex-c-m flex-w w-full p-t-45">
				<Link to="#" className="flex-c-m stext-101 cl5 size-103 bg2 bor1 hov-btn1 p-lr-15 trans-04">
					Load More
				</Link>
			</div>
		</div>
	</section>

</div>
 }
 
 }